import React, { useState } from "react";
import ReactSpeedometer from "react-d3-speedometer";
import { Card, Button, Container, Row, Col } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css"; // Import Bootstrap styles

const SpeedometerComponent = ({totalObligationAmount=0,MaxSalary=0,formik}) => {
//   const [value, setValue] = useState(50); // Initial value of the speedometer

//   // Simulate a value change (can be connected to any dynamic source like API)
//   const handleIncrease = () => {
//     setValue((prevValue) => Math.min(100, prevValue + 10));
//   };

//   const handleDecrease = () => {
//     setValue((prevValue) => Math.max(0, prevValue - 10));
//   };

  return (
    
      
        <div className="col-md-6 mb-2">
          <Card>
            <Card.Body className="bg-white">
              {/* {JSON.stringify(formik.values)} */}
              <Card.Title className="text-center">Obligation {Math.floor(Math.min(totalObligationAmount, 100),2)}% </Card.Title>
              <ReactSpeedometer
                value={Math.min(totalObligationAmount, 100)}
                minValue={0}
                //segmentColors={['#E6E6E6', '#FF6347', '#FFA07A', '#FF4500']}
                maxValue={MaxSalary}
                segments={10}
                needleColor="red"
                startColor="#00FF00"
                endColor="#990100"
                ringWidth={30}
                currentValueText={`Obligation: ${ Math.floor(Math.min(totalObligationAmount, 100),2) }%`}
              />
              
              {false && <div className="d-flex justify-content-between mt-4">
                <Button variant="success" >
                  Increase
                </Button>
                <Button variant="danger" >
                  Decrease
                </Button>
              </div>
              }

            </Card.Body>
          </Card>
        </div>
      
   
  );
};

export default SpeedometerComponent;
